import React from "react";
import "../../City/CityInfo/style.css";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "components/Button/Button";
import CoverPhoto from "pages/City/CityInfo/CoverPhoto";
//import SocialMedia from "pages/City/CityInfo/SocialMedia";
//import CityAdmin from "pages/City/CityInfo/CityAdmin";
import PlaceholderImage from "Assets/present-img.png";
//import { apiUrl, myHeaders_Autorized, HeaderConfig,events_list_api, channel_list_api, myHeaders_With_Cache_Control } from "Api/Api";
import { org_friendly_url, apiUrl, myHeaders_Authorized, myHeaders_With_Cache_Control } from "Api/Api";
import axios from 'axios';
// import { NavLink } from "react-router-dom";
import { local_routes, feature_names } from 'utils/Routes';
import { get_current_unix_stamp } from 'utils/Helper';
import ActivityIndicator from "components/ActivityIndicator/ActivityIndicator";
import Select from 'react-select';
import MultiSelect from "components/MultiSelectSearch/MultiSelect";

class WorkspaceInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            workspace_image: null, // returned from CoverPhoto
            workspace_banner_image: null, // returned from CoverPhoto
            updateWorkspaceLoader: false,
            loading: true,
            org_data: {},
            org_pks_options: [],
            selected_spotlighted_pk_option: null,
            selected_featured_pk_options: [],
            message: null,
            //remove_featured_pks: []
        };
        
        this.updateable_fields = [
            'description',
            //'spotlighted_presentations_uuid',
            //'featured_presentations_uuids'
        ];
        
        this.workspace_base_url = "";
        const { match: { params: { org_friendly_url } = {} } = {} } = this.props;
        if (org_friendly_url) {
          this.workspace_base_url = local_routes.workspace+"/"+org_friendly_url;
        }
    }

    componentDidMount = async function () {
        await this.getFromApi();
    }

    getFromApi = async () => {
        this.setState({ loading: true, message: null });
        let new_state = {...this.state};
        console.log("WorkspaceInfo getFromApi new_state",JSON.stringify(new_state,null,2));
        try {
            let [org_data_response,org_pks] = await Promise.all([
                axios.get(`${apiUrl}organizations/${org_friendly_url}`, myHeaders_With_Cache_Control),
                axios.get(`${apiUrl}organizations/${org_friendly_url}/presentations`, myHeaders_With_Cache_Control)
            ]);
            new_state.org_data = org_data_response.data;
            //new_state.orig_org_data = {...org_data_response.data};

            let org_pks_options = [];
            
            org_pks_options.push({
                value: '00000000-0000-0000-0000-000000000000',
                label: 'None'
            });
            new_state.selected_spotlighted_pk_option = org_pks_options[0];
            
            org_pks.data = org_pks.data.sort((a, b) => a.entity_name.localeCompare(b.entity_name));
            
            org_pks.data.forEach((item,index) => {
                let org_pk_option = {
                    value: item.entity_uuid,
                    label: item.entity_name
                };
                org_pks_options.push(org_pk_option);
                if (org_data_response.data.spotlighted_presentations_uuid && org_data_response.data.spotlighted_presentations_uuid === item.entity_uuid) {
                    new_state.selected_spotlighted_pk_option = org_pk_option;
                }
                if (org_data_response.data.featured_presentations_uuids && org_data_response.data.featured_presentations_uuids.includes(item.entity_uuid)) {
                    new_state.selected_featured_pk_options.push(org_pk_option);
                }
                new_state.selected_featured_pk_options = new_state.selected_featured_pk_options.sort((a, b) => (a.featured_time > b.featured_time) ? 1 : -1);
            });
            new_state.org_pks_options = org_pks_options;
            
            new_state.message = null;
            new_state.loading = false;
 
            //console.log("WorkspaceInfo componentDidMount new_state",JSON.stringify(new_state,null,2));
            this.setState(new_state);
        } catch (err) {
            console.error("Org not found!",err);
            this.setState({loading:false});
        }
        window.scrollTo(0, 0);
    }

    // generic handler for <Form> fields
    handleChangeFormValue = (event) => {
        let updated_org_data = {...this.state.org_data};

        updated_org_data[event.target.id] = event.target.value;
        this.setState({
            org_data: updated_org_data
        });
    }
    
    // handler for changing spotlighted PK dropdown
    handleChangeSpotlightedPk = async (selectedOption) => {
        let updated_org_data = {...this.state.org_data};
        
        updated_org_data.spotlighted_presentations_uuid = selectedOption.value;
        
        this.setState({
            selected_spotlighted_pk_option: selectedOption,
            org_data: updated_org_data
        });
        
        let patch_data = {
            presentations: []
        };
        
        if (this.state.org_data.spotlighted_presentations_uuid) {
            // unset old xref
            patch_data.presentations.push(
                {
                    entity_uuid: this.state.org_data.spotlighted_presentations_uuid,
                    xref_data: {
                        spotlighted_time: -1
                    }
                }
            );
        }
        
        if (selectedOption.label !== 'None') {
            // add new xref
            patch_data.presentations.push(
                {
                    entity_uuid: selectedOption.value,
                    xref_data: {
                        spotlighted_time: get_current_unix_stamp()
                    }
                }
            );
        }
        
        patch_data.spotlighted_presentations_uuid = selectedOption.value;
        
        await axios.patch(`${apiUrl}organizations/${this.state.org_data.entity_uuid}`, patch_data);

        // bust cache
        await axios.get(`${apiUrl}organizations/${this.state.org_data.friendly_url}/presentations?do_recursive=true&sort_obj=${encodeURIComponent('{"spotlighted_time":"desc"}')}&limit=1`,myHeaders_With_Cache_Control)
        await axios.get(`${apiUrl}organizations/${this.state.org_data.friendly_url}`,myHeaders_With_Cache_Control)
    }
    
    // getChangedImg called from CoverPhoto component
    getChangedImg = (imgData) => {
        this.setState({ workspace_image: imgData });
    }
    
    // getChangedImg called from CoverPhoto component
    getChangedImgBanner = (imgData) => {
        this.setState({ workspace_banner_image: imgData });
    }

    updateWorkspace = async () => {
        console.log("WorkspaceInfo updateWorkspace",JSON.stringify(this.state.org_data,null,2));
        this.setState({ updateWorkspaceLoader: true });
        
        if (this.state.workspace_image !== null) {
            // getting array buffer
            let coverPicPromise = new Promise(resolve => {
                let reader = new FileReader();
                reader.readAsArrayBuffer(this.state.workspace_image);
                reader.onload = () => resolve(reader.result);
            });
            
            let coverImgName = this.state.workspace_image.name.replace(/[^A-Za-z0-9.]/g, "");
            let image_upload_data = await axios.post(`${apiUrl}organizations/${this.state.org_data.entity_uuid}/getUploadSignedUrl?asset_type=image&filename=${coverImgName}`, {}, myHeaders_Authorized);
            const config = { headers: { "Content-Type": image_upload_data.data.content_type } };
            let uploadUrl = image_upload_data.data.upload_url;
            let arrVal = await coverPicPromise;
            await axios.put(uploadUrl, arrVal, config);
        }
        
        if (this.state.workspace_banner_image !== null) {
            // getting array buffer
            let coverPicPromise = new Promise(resolve => {
                let reader = new FileReader();
                reader.readAsArrayBuffer(this.state.workspace_banner_image);
                reader.onload = () => resolve(reader.result);
            });
            
            let coverImgName = this.state.workspace_banner_image.name.replace(/[^A-Za-z0-9.]/g, "");
            let image_upload_data = await axios.post(`${apiUrl}organizations/${this.state.org_data.entity_uuid}/getUploadSignedUrl?asset_type=banner_image&filename=${coverImgName}`, {}, myHeaders_Authorized);
            const config = { headers: { "Content-Type": image_upload_data.data.content_type } };
            let uploadUrl = image_upload_data.data.upload_url;
            let arrVal = await coverPicPromise;
            await axios.put(uploadUrl, arrVal, config);
        }
        
        let patch_obj = {};
        //patch_obj.presentations = [];
        //patch_obj.presentations = this.state.org_data.presentations;
        
        
        for (let updateable_field of this.updateable_fields) {
            patch_obj[updateable_field] = this.state.org_data[updateable_field];
        }
        
        /*
        if (patch_obj.spotlighted_presentations_uuid) {
            // also update the xref
            patch_obj.presentations = [
                {
                    entity_uuid: patch_obj.spotlighted_presentations_uuid,
                    xref_data: {
                        spotlighted_time: get_current_unix_stamp()
                    }
                }
            ];
        }
        */
        
        /*
        if (patch_obj.featured_presentations_uuids) {
            // also update the xref
            let tmp_featured_presentation_items = [];
            let current_unix_stamp = get_current_unix_stamp();
            patch_obj.featured_presentations_uuids.forEach( uuid => {
                tmp_featured_presentation_items.push(
                    {
                        entity_uuid: uuid,
                        xref_data: {
                            featured_time: current_unix_stamp
                        }
                    }
                );
            });
            patch_obj.presentations = patch_obj.presentations.concat(tmp_featured_presentation_items);
        }
        // if we are removing featured PKs, must set xref to -1
        if (this.state.remove_featured_pks.length > 0 && this.state.orig_org_data.featured_presentations_uuids) {
            let tmp_remove_featured_pks_uuids = this.state.orig_org_data.featured_presentations_uuids.filter( uuid => this.state.remove_featured_pks.includes(uuid));
            console.log("REMOVE?",this.state.remove_featured_pks,this.state.orig_org_data.featured_presentations_uuids,tmp_remove_featured_pks_uuids);
            tmp_remove_featured_pks_uuids.forEach( uuid => {
                patch_obj.presentations.push({
                    entity_uuid: uuid,
                    xref_data: {
                        featured_time: -1
                    }
                });
            });
        }
        */

        if (Object.keys(patch_obj).length > 0) {
            await axios.patch(`${apiUrl}organizations/${this.state.org_data.entity_uuid}`, patch_obj, myHeaders_Authorized);
            // now bust cache
            await Promise.all([
                axios.get(`${apiUrl}organizations/${this.state.org_data.friendly_url}`,myHeaders_With_Cache_Control),
                //axios.get(`${apiUrl}organizations/${this.state.org_data.friendly_url}/presentations?do_recursive=true&sort_obj=${encodeURIComponent('{"spotlighted_time":"desc"}')}&limit=1`,myHeaders_With_Cache_Control)
            ]);
        }
        
        this.setState({
            updateWorkspaceLoader: false,
            message: `${feature_names.Workspace} Updated Successfully`,
            //orig_org_data: {...this.state.org_data},
            //remove_featured_pks: []
        });
        
        window.scrollTo(0, 0);
    }

    // Multi Select categories Method handler
    multiSearchSelectDataMet = async (add_Cat,remove_Cat,store_Cat) => {
        console.log("multiSearchSelectDataMet",add_Cat,remove_Cat,store_Cat);
        
        let patch_data = {};
        for (let presentation_obj of add_Cat) {
            patch_data.presentations = [
                {
                    entity_uuid:presentation_obj.value,
                    xref_data: {
                        featured_time: get_current_unix_stamp()
                    }
                }
            ];
            
            //axios.patch(`${apiUrl}organizations/${this.state.org_data.entity_uuid}`, patch_data);
        }
        
        // remove_Cat will call DELETE /rest/presentations/<presentation_uuid>/categories/<category_uuid>
        for (let presentation_obj of remove_Cat) {
            patch_data.presentations = [
                {
                    entity_uuid:presentation_obj.value,
                    xref_data: {
                        featured_time: -1
                    }
                }
            ];
            
            //axios.patch(`${apiUrl}organizations/${this.state.org_data.entity_uuid}`, patch_data);
        }
        
        let tmp_featured_presentation_uuids = store_Cat.map (element => element.value);
        patch_data.featured_presentations_uuids = tmp_featured_presentation_uuids
        await axios.patch(`${apiUrl}organizations/${this.state.org_data.entity_uuid}`, patch_data);

        // now bust cache        
        await axios.get(`${apiUrl}organizations/${this.state.org_data.friendly_url}/presentations?do_recursive=true&filter_obj=${encodeURIComponent('{"featured_time":{"gte":1}}')}&sort_obj=${encodeURIComponent('{"featured_time":"desc"}')}&limit=60`,myHeaders_With_Cache_Control);

        /*
        // update org_data.presentations array; add_Cat/remove_Cat will always be length of 1
        let new_state = {...this.state}
        let updated_org_data_presentations = [...this.state.org_data.presentations];
        if (remove_Cat.length > 0) {
            for (let presentation_obj of updated_org_data_presentations) {
                if (presentation_obj.xref_data && presentation_obj.xref_data.featured_time) {
                    // remove?
                    if (remove_Cat[0].value === presentation_obj.entity_uuid) {
                        presentation_obj.xref_data.featured_time = -1                    
                    }
                }
            }
        }
        if (add_Cat.length > 0) {
            let found = false;
            for (let presentation_obj of updated_org_data_presentations) {
                if (add_Cat[0].value === presentation_obj.entity_uuid) {
                    found = true;
                    presentation_obj.xref_data.featured_time = get_current_unix_stamp();
                }

            }
            if (!found) {
                // add to presentations array
                updated_org_data_presentations.push({
                    entity_uuid: add_Cat[0].value,
                    xref_data: {
                        featured_time: get_current_unix_stamp()
                    }
                });
            }
        }
        new_state.org_data.presentations = updated_org_data_presentations;
        new_state.featured_presentation_uuids = store_Cat.map (element => element.value);
        */
        /*
        let tmp_featured_presentation_uuids = [];
        let tmp_remove_featured_pks_uuids = [];
        store_Cat.forEach( item => {
            tmp_featured_presentation_uuids.push(item.value);
        });
        let new_state = {...this.state};
        //let updated_org_data = {...this.state.org_data};
        if (remove_Cat.length > 0) {
            tmp_remove_featured_pks_uuids = remove_Cat.map( element => element.value);
            new_state.remove_featured_pks = new_state.remove_featured_pks.concat(tmp_remove_featured_pks_uuids);
            //this.setState({
            //   remove_featured_pks: tmp_remove_featured_pks_uuids 
            //});
        }
        new_state.org_data.featured_presentations_uuids = tmp_featured_presentation_uuids;
        */
        
        //console.log("multiSearchSelectDataMet update_state",new_state);
        //this.setState(new_state);
    }


    render() {
        //const { updateCityLoader, channelEntityId, channelImg, twitter, facebook, instagram, channelFriendly_url, channelDescription,
        //    channelAdminData, loading, presentationDataArr,selectedData } = this.state;
            
        if (this.state.loading) {
            return (
                <div className="createEventSpinner">
                    <ActivityIndicator theme="spinner" />
                </div>
            );
        }

        let logo_url;
        if (this.state.org_data.image_url) {
            logo_url = this.state.org_data.image_url;
            let array = logo_url.split("/");
            logo_url=`${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/padwhite_noborder_200x45/${array[5]}`;
        }
        
        let banner_url;
        if (this.state.org_data.banner_image_url) {
            banner_url = this.state.org_data.banner_image_url;
            let array = banner_url.split("/");
            banner_url=`${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/padtransparent_noborder_800x200/${array[5]}`;
        }
        
        return (
            <div className="city-info">
                <div className="container pad-bot30">
                    <Row className="pad-top70 pad-bot30 editCity">
                        <Col lg={6} md={6} sm={6} className="pad0" >
                            <h1>{feature_names.Workspace} Info</h1>
                            { this.state.message &&
                                <span style={{color:"green", paddingTop: "10px"}}>{this.state.message}</span>
                            }
                        </Col>
                        <Col lg={6} md={6} sm={6} className="pad0" >
                            <div className="cityUpdate-btn">
                                {
                                    this.state.updateWorkspaceLoader === false ?
                                    <React.Fragment>
                                        <Button OnClickMet={this.getFromApi} theme="btn-global btn-hover btn-cancel ">Cancel</Button>
                                        <Button OnClickMet={this.updateWorkspace} theme="btn-global btn-hover btn-green btn-update">Update {feature_names.Workspace}</Button>
                                    </React.Fragment>
                                    :
                                    <ActivityIndicator theme="button-Status-Loader" />
                                }
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={12} className="pad0" >
                            <Form.Group controlId="description">
                                <Form.Label>DESCRIPTION</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    value={this.state.org_data['description']}
                                    onChange={this.handleChangeFormValue}
                                    placeholder={`Write 2-4 sentences that describe your ${feature_names.workspace}`}
                                    rows="6"
                                    required
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={12} className="coverphoto pad0 mb-4">
                            <div className="pad-tb30 cover-border">
                                <h3>Spotlighted PK</h3>
                                <p>Please select one (or 'None' to hide the component) Spotlighted PK to show in spotlighted section (the top) of your {feature_names.workspace} home page</p>
                                <p>Changes made here are immediate and do not require an 'Update Team' click</p>
                            </div>
                            <Row>
                                <Col md={7}>
                                    <div className="presentation-multi-select mb-3">
                                        <Select
                                            closeMenuOnSelect={true}
                                            value={this.state.selected_spotlighted_pk_option}
                                            onChange={this.handleChangeSpotlightedPk}
                                            options={this.state.org_pks_options}
                                            isMulti={false}
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={12} className="coverphoto pad0 mb-4">
                            <div className="pad-tb30 cover-border">
                                <h3>Featured PKs</h3>
                                <p>If one or more PKs are selected, these will replace the 'Trending' PKs of your {feature_names.workspace} home page</p>
                                <p>Changes made here are immediate and do not require an 'Update Team' click</p>
                            </div>
                            <Row>
                                <Col md={7}>
                                    <div className="presentation-multi-select mb-3">
                                       <MultiSelect
                                            //component_type="category"
                                            //Categories={this.state.Categories}
                                            //Category_Names={this.state.Category_names}
                                            multiSearchSelectData={this.multiSearchSelectDataMet}
                                            Category_keys={this.state.org_pks_options}
                                            selectedCategories={this.state.selected_featured_pk_options || []}
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row className="cover-photo">
                        <CoverPhoto
                            cityEntityId={this.state.org_data.entity_uuid}
                            //cityImg={this.state.org_data.image_url}
                            cityImg={logo_url}
                            changedImg={this.getChangedImg}
                            currentImageText={"CURRENT LOGO IMAGE"}
                            replaceImageBtn={"Replace Logo Image"}
                            coverHead="Logo Image"
                            coverDescription={`Displayed at the top-left of your ${feature_names.workspace} pages. Recommended image size: 200x45.`}
                            coverImage={PlaceholderImage}
                        />
                    </Row>
                    <Row className="cover-photo">
                        <CoverPhoto
                            cityEntityId={this.state.org_data.entity_uuid}
                            //cityImg={this.state.org_data.image_url}
                            cityImg={banner_url}
                            changedImg={this.getChangedImgBanner}
                            currentImageText={"LARGE BANNER IMAGE"}
                            replaceImageBtn={"Replace Banner Image"}
                            coverHead="Banner Image"
                            coverDescription={`Displayed across the top of your ${feature_names.workspace} pages. Wide format (1600x400 pixels, 4:1 ratio) recommended.`}
                            coverImage={PlaceholderImage}
                        />
                    </Row>
                    <Row className="d-flex justify-center">
                        <div className="cityUpdate-btn">
                           {
                                this.state.updateWorkspaceLoader === false ?
                                <React.Fragment>
                                    <Button OnClickMet={this.getFromApi} theme="btn-global btn-hover btn-cancel ">Cancel</Button>
                                    <Button OnClickMet={this.updateWorkspace} theme="btn-global btn-hover btn-green btn-update">Update {feature_names.Workspace}</Button>
                                </React.Fragment>
                                :
                                <ActivityIndicator theme="button-Status-Loader" />
                            }
                        </div>
                    </Row>
                </div>
            </div>
        );
        

    }
}

export default WorkspaceInfo;
